<template>
  <div>
    <vx-card ref="filterCard" class="user-list-filters mb-8" collapse-action>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
        <div class="vx-row mb-2">
          <div class="vx-col w-1/3">
            <validation-provider name="วันที่ต้องการปิดยอดชำระ" rules="required" v-slot="{ errors }">
              <label class="vs-input--label">วันที่ต้องการปิดยอดชำระ*</label>
              <flat-pickr :config="configDatePicker" class="w-full" v-model="form.reportDate"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="vx-col w-2/3">
            <validation-provider :name="$t('sections.prosecution.dataForm.contract')" rules="required" v-slot="{ errors }">
              <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.contract") }}*</label>
              <v-select v-model="form.contract" :clearable="true" :options="contractOptions" name="contract" :reduce="res => res.value" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="vx-row mb-2 flex">
          <div class="vx-col ml-auto">
            <vs-button color='success' @click="download" class="mr-2">{{ $t("general.download") }}</vs-button>
            <vs-button color='warning' @click="reset">{{ $t("general.reset") }}</vs-button>
          </div>
        </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import {ValidationProvider} from "vee-validate";
const { mapActions: mapAccountingActions } = createNamespacedHelpers('Accounting');
const moment = require('moment');
const minDate = moment().format("DD-MM-YYYY");
const maxDate = moment().date() <= 5 ? moment().date(5).format("DD-MM-YYYY") : moment().add(1, 'M').date(5).format("DD-MM-YYYY");

export default {
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data () {
    return {
      reportServer: process.env.VUE_APP_REPORT_SERVER,
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      },
      form:{
        contract: "",
        reportDate: moment().format("DD-MM-YYYY"),
      },
    }
  },
  computed: {
    ...mapGetters({
      contractOptions: "Accounting/contractOptions",
    }),
  },
  methods: {
    ...mapAccountingActions(['getContractOptions']),
    _onChangeYears(e) {
      this.onChangeYears(e)
    },
    async loadOptions() {
      const vm = this
      const { getContractOptions } = vm
      if(vm.contractOptions.length === 0) await getContractOptions();
    },
    async initData() {

    },
    async download (){
      const vm = this

      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        const params = {
          contract: vm.form.contract,
          reportDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.reportDate),
        };

        const queryString = new URLSearchParams(params).toString();
        window.open(`${vm.reportServer}/pdf/reportClosureNotification?${queryString}`, '_blank');
      })
    },
    async reset(){
      this.form = {
        contract: "",
        reportDate: moment().format("DD-MM-YYYY"),
      }
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
  async created() {
    const vm = this
    vm.$vs.loading();
    await vm.loadOptions();
    await vm.initData();
    vm.$vs.loading.close();
  },
}
</script>
